import { RouterProvider } from "@tanstack/react-router";
import { useRef } from "react";

import { createUpgradePlanRouter } from "./router";

interface UpgradePlanRouterProps {
  initialPath: string;
}

export const UpgradePlanRouter = ({ initialPath }: UpgradePlanRouterProps) => {
  // Built once per mount from whichever `initialPath` was computed first, then
  // navigation happens through the router's own history. Recreating the
  // router whenever `initialPath` recomputes (e.g. a background refetch
  // triggered by a screen further down the flow) would tear down whatever
  // screen the customer is currently looking at and drop them back at a
  // freshly-derived initial screen instead.
  const routerRef = useRef<ReturnType<typeof createUpgradePlanRouter> | null>(
    null,
  );
  if (routerRef.current === null) {
    routerRef.current = createUpgradePlanRouter(initialPath);
  }

  return <RouterProvider router={routerRef.current} />;
};
